





import { Component, Vue, Prop } from 'vue-property-decorator';
import { Chrome } from 'vue-color';
import gaClickOutside from '../../directives/ga-click-outside';

interface VueColorString {
  hex: string;
  hex8: string;
  hsl: {
    a: number;
    h: number;
    s: number;
    l: number;
  };
  hsv: {
    a: number;
    h: number;
    s: number;
    v: number;
  };
  rgba: {
    a: number;
    r: number;
    g: number;
    b: number;
  };
}

@Component({
  name: 'BaseColorPicker',
  components: {
    'ga-color-picker': Chrome,
  },
  directives: {
    gaClickOutside,
  },
})
export default class BaseColorPicker extends Vue {
  @Prop() color: string;

  handleUpdateColor(color: VueColorString) {
    this.$emit('update-color', color.hex8);
  }

  handleHide() {
    this.$emit('hide');
  }
}
